module.exports = __webpack_public_path__ + "3a61fe9c5a0dfa3dc4876a510ae6c2c2.svg";